/* eslint max-len: off */
import React from 'react';
import {Icon} from '../createSvg';
import {IconProps} from '../types';

export const Forth = (props: IconProps) => (
  <Icon {...props}>
    <path
      d="M14.5581 7.7125L17.5065 10.5925H4.02375C3.46069 10.5925 3 11.0425 3 11.5925C3 12.1425 3.46069 12.5925 4.02375 12.5925H17.5065L14.5581 15.4725C14.1588 15.8625 14.1588 16.4925 14.5581 16.8825C14.9573 17.2725 15.6023 17.2725 16.0016 16.8825L20.7006 12.2925C21.0998 11.9025 21.0998 11.2725 20.7006 10.8825L16.0016 6.2925C15.6023 5.9025 14.9573 5.9025 14.5581 6.2925C14.1691 6.6825 14.1588 7.3225 14.5581 7.7125Z"
    />
  </Icon>
);
